







import { Component, Vue } from "vue-property-decorator";
import * as firebase from "firebase";

@Component
export default class Loggedin extends Vue {
  private isError: boolean = false;
  private errorMessage: string = '';

  mounted (): void {
    this.$store.dispatch('login')
      .then((result) => {
        this.$router.push('/overview-sample');
      })
      .catch((err) => {
        console.log(err);
        this.$router.push('/');
      });
  }

}
